// auth
export const userViewer = 'res:auth:user.viewer'
export const userWriter = 'res:auth:user.writer'
export const userAdmin = 'res:auth:user.admin'

export const clientViewer = 'res:auth:client.viewer'
export const clientWriter = 'res:auth:client.writer'
export const clientAdmin = 'res:auth:client.admin'

export const roleViewer = 'res:auth:role.viewer'
export const roleWriter = 'res:auth:role.writer'
export const roleAdmin = 'res:auth:role.admin'

export const partnerViewer = 'res:auth:partner.viewer'
export const partnerWriter = 'res:auth:partner.writer'
export const partnerAdmin = 'res:auth:partner.admin'

export const settingViewer = 'res:auth:setting.viewer'
export const settingWriter = 'res:auth:setting.writer'
export const settingAdmin = 'res:auth:setting.admin'

export const activityViewer = 'res:activity.viewer'
export const activityWriter = 'res:activity.writer'
export const activityAdmin = 'res:activity.admin'

export const consoleViewer = 'res:console.viewer'
export const consoleWriter = 'res:console.writer'
export const consoleAdmin = 'res:console.admin'

// project
export const projectViewer = 'res:project.viewer'
export const projectWriter = 'res:project.writer'
export const projectAdmin = 'res:project.admin'

//dashboard
export const dashboardWriter = 'res:dashboard.writer'

//deployment
export const deploymentViewer = 'res:deployment.viewer'
export const deploymentWriter = 'res:deployment.writer'
export const deploymentAdmin = 'res:deployment.admin'

//transaction
export const transactionViewer = 'res:transaction.viewer'
export const transactionWriter = 'res:transaction.writer'
export const transactionAdmin = 'res:transaction.admin'

//survey
export const surveyViewer = 'res:survey.viewer'
export const surveyWriter = 'res:survey.writer'
export const surveyAdmin = 'res:survey.admin'

export const generateLinkViewer = 'res:survey:link.viewer'
export const generateLinkWriter = 'res:survey:link.writer'

//closeloop
export const closeloopViewer = 'res:closeloop.viewer'
export const closeloopWriter = 'res:closeloop.writer'
export const closeloopAdmin = 'res:closeloop.admin'

//report
export const reportViewer = 'res:report.viewer'
export const reportWriter = 'res:report.writer'
export const reportAdmin = 'res:report.admin'

//quota
export const quotaViewer = 'res:quota.viewer'
export const quotaWriter = 'res:quota.writer'
export const quotaAdmin = 'res:quota.admin'

//quota response limit
export const quotaLimitViewer = 'res:quota:limit.viewer'
export const quotaLimitWriter = 'res:quota:limit.writer'

//quota response limit
export const quotaCallcenterViewer = 'res:quota:callcenter.viewer'
export const quotaCallcenterWriter = 'res:quota:callcenter.writer'

//callcenter
export const callcenterViewer = 'res:access:project.viewer'
export const callcenterWriter = 'res:access:project.writer'


export const clientRole = 'res:auth:client'
export const partnerRole = 'res:auth:partner'

